module.exports = __webpack_public_path__ + "img/HSBC Bank.e2d8dece.png";